module.exports = __webpack_public_path__ + "assets/img/Type E (50).892cd567.jpg";